module.exports = __webpack_public_path__ + "1d774a7e03e81ea25481418a36bd205b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/elogo.png
// module id = 1307
// module chunks = 61